var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrissCrossSmallNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 23,
    viewBox: "0 0 135 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.27651C32.4674 1.77141 62.5304 1.27811 92.9881 3.07417C100.995 3.54634 108.839 5.38214 116.795 6.18933C121.788 6.69581 126.708 9.0166 131.705 9.19518C132.132 9.21046 133.857 9.44836 132.47 8.97657C127.854 7.40735 122.833 8.21145 118.151 8.21145C104.121 8.21145 90.3303 10.1125 76.4101 12.6383C67.7478 14.21 58.8452 17.2693 50.1702 18.0488C37.6632 19.1726 75.178 21 87.7054 21",
    stroke: "url(#paint0_linear_2255_4220)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2255_4220",
    x1: 133,
    y1: 11.5,
    x2: 2,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C93C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FC0004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#921A98"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrissCrossSmallNew);
export default __webpack_public_path__ + "static/media/crissCrossSmallNew.47a0c1b1.svg";
export { ForwardRef as ReactComponent };